var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentHeader',{attrs:{"material-nav":true,"show-back":false}}),_c('div',{staticClass:"content-container"},[_c('ItemList',{attrs:{"item-type":'printing'},on:{"toTemplate":_vm.toTemplate,"toFavourite":_vm.toFavourite}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }